import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import Button from '../orders/css';
import { getPdfUrl } from '../utils/utils';
import { orderStatus, fmFilterStatuses, roleName,quoteStatus } from '../utils/constant';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import { useLocaleContext } from '../context/LocaleContext';
import EN from '../../EN.json';
import FR from '../../FR.json';

const getLink = (id, label) => {
  const locale = useLocaleContext();
  return (
    <a
      className="download-link"
      href={getPdfUrl(id, locale)}
      target="_blank"
      rel="noopener noreferrer"
    >
      {label}
    </a>
  );
};

const Tooltip = ({ children }) => {
  const localizedStrings = useLocalizedStringsContext();
  const { tooltipMessage } = localizedStrings.srtDashboard;
  return (
    <>
      {children}
      <div
        data-type="info"
        data-tip="React-tooltip"
        style={{ display: 'inline', marginLeft: '8px' }}
      >
        <i className="fa fa-question-circle"></i>
      </div>
      <ReactTooltip type="info" effect="float">
        {tooltipMessage}
      </ReactTooltip>
    </>
  );
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired
};

const getButton = (onClick, label, isDisabled) => (
  <Button onClick={onClick} disabled={isDisabled}>
    {label}
  </Button>
);

const getStatus = order => {
  const local = useLocaleContext();

  const {
    OCDR: {
      orderDashoard: { status }
    }
  } = local === 'en-US' ? EN : FR;

  const incomplete = order === orderStatus.incomplete;
  const pendingApproval = order === quoteStatus.pendingApproval;
  const quoteApproved = order === quoteStatus.approved;
  const quoteRejected = order === quoteStatus.rejected;
  const contractSend = order === orderStatus.contractSend;
  const contractSigned = order === orderStatus.contractSigned;
  const completed = order === orderStatus.submitted;
  const orderCanceled = order === orderStatus.canceled;
  const sendtoAccountManager = order === orderStatus.SendBacktoAccountManager;
  const sendBacktoSlaesRep = order === orderStatus.SendBacktoPreSalesEngineer;

  const statusList = {
    [incomplete]: status.orderIncomplete,
    [pendingApproval]: status.pendingApproval,
    [contractSend]: status.contractSent,
    [contractSigned]: status.contractSigned,
    [completed]: status.orderCompleted,
    [orderCanceled]: status.orderCanceled,
    [sendtoAccountManager]: status.sendBacktoAccountManager,
    [sendBacktoSlaesRep]: status.sendBacktoSalesRep,
    [quoteApproved]: status.quoteApproved,
    [quoteRejected]: status.quoteRejected
  };

  return statusList.true;
};

const filterValueToStatusesMap = {
  [fmFilterStatuses.incomplete]: {
    orderStatus: orderStatus.incomplete
  },
  [fmFilterStatuses.submitted]: {
    orderStatus: orderStatus.submitted
  },
  [fmFilterStatuses.pendingValidation]: {
    orderStatus: orderStatus.pendingValidation
  },
  [fmFilterStatuses.orderCanceled]: {
    orderStatus: orderStatus.canceled
  },
  [fmFilterStatuses.contractSigned]: {
    orderStatus: orderStatus.contractSigned
  },
  [fmFilterStatuses.contractSent]: {
    orderStatus: orderStatus.contractSend
  },
  [fmFilterStatuses.sendBacktoAccountManager]: {
    orderStatus: orderStatus.SendBacktoAccountManager
  },
  [fmFilterStatuses.sendBacktoSalesRep]: {
    orderStatus: orderStatus.SendBacktoPreSalesEngineer
  },
  [fmFilterStatuses.pendingApproval]:{
    orderStatus: orderStatus.pendingApproval
  },
  [fmFilterStatuses.quoteApproved]:{
    orderStatus: orderStatus.quoteApproved
  },
  [fmFilterStatuses.quoteRejected]:{
    orderStatus: orderStatus.quoteRejected
  }
};

const getStatusFiltersPayload = filters => {
  const statuses = [];
  filters.forEach(element => {
    if (filterValueToStatusesMap[element.value]) {
      const correspondingOrderStatus =
        filterValueToStatusesMap[element.value].orderStatus;

      if (
        correspondingOrderStatus &&
        !statuses.includes(correspondingOrderStatus)
      )
        statuses.push(correspondingOrderStatus);
    }
  });
  return { status: statuses };
};

const salesRepAction = (orderStatus) => {
    return orderStatus === fmFilterStatuses.pendingValidation;
};


const exactCompareArray = (arrOne, arrTwo) => {
  return (
    arrOne.length === arrTwo.length &&
    arrOne.filter((currVal, idx) => currVal !== arrTwo[idx]).length === 0
  );
};

const getOrderType = (productSelected = []) => {
  const local = useLocaleContext();
  const {
    OCDR: {
      orderDashoard:{
      productDRMS,
      productOCMS,
      msCloud,
      directRouting,
      operatorConnect,
      orderType
    }
  }
  } = local === 'en-US' ? EN : FR;
  let type = '';
  if (exactCompareArray(productOCMS, productSelected)) {
    type = orderType.productOCMS;
  } else if (exactCompareArray(productDRMS, productSelected)) {
    type = orderType.productDRMS;
  } else if (exactCompareArray(msCloud, productSelected)) {
    type = orderType.msCloud;
  } else if (exactCompareArray(directRouting, productSelected)) {
    type = orderType.directRouting;
  } else if (exactCompareArray(operatorConnect, productSelected)) {
    type = orderType.operatorConnect;
  } else {
    type = '-';
  }
  return type;
};

export {
  getLink,
  getButton,
  getStatus,
  getStatusFiltersPayload,
  salesRepAction,
  getOrderType
};
